let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dAz8I")).then(() => parcelRequire('6hj0p'));